import React from "react";
import { Heart } from "lucide-react";
import { merch } from "../../mock/mock";

const SloganArt = ({ slogan, light }) => {
  const color = light ? "#822432" : "#FFFFFF";
  const shadow = light
    ? "none"
    : "0 2px 10px rgba(0,0,0,0.4)";

  if (slogan === "Overdressed") {
    return (
      <span
        className="font-display text-2xl md:text-3xl tracking-wide-sm uppercase text-center leading-none"
        style={{ color, textShadow: shadow }}
      >
        Overdressed
      </span>
    );
  }
  return (
    <div
      className="flex flex-col items-center leading-tight text-center"
      style={{ color, textShadow: shadow }}
    >
      <span className="font-display text-lg md:text-2xl tracking-wide-sm">
        PRETTY
      </span>
      <span className="font-display text-lg md:text-2xl tracking-wide-sm inline-flex items-center gap-1.5">
        POLISHED
        <Heart
          size={14}
          strokeWidth={2.4}
          style={{ color }}
          fill={color}
        />
      </span>
      <span className="font-display text-lg md:text-2xl tracking-wide-sm">
        PURPOSEFUL
      </span>
    </div>
  );
};

const MerchHeading = () => (
  <div className="text-center mb-14">
    <p className="font-body text-xs font-semibold tracking-wide-sm uppercase text-[#C8102E] mb-4">
      Support the Movement
    </p>
    <h2 className="font-display text-4xl md:text-6xl text-[#1A1A1A] mb-4">
      Support Merch
    </h2>
    <p className="font-body text-[#555] text-sm md:text-base max-w-xl mx-auto">
      Wear it loud. Tees, caps & leggings repping{" "}
      <span className="text-[#822432] font-semibold">Overdressed</span> and{" "}
      <span className="text-[#822432] font-semibold">
        Pretty Polished &amp; Purposeful
      </span>
      . Dropping soon.
    </p>
  </div>
);

const MerchCard = ({ item }) => (
  <div className="group">
    <div className="relative aspect-square overflow-hidden rounded-2xl bg-[#F4F4F4] mb-4">
      <img
        src={item.image}
        alt={`${item.type} - ${item.slogan}`}
        className="w-full h-full object-cover img-hover"
      />
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none px-6">
        <div className="max-w-[70%]">
          <SloganArt slogan={item.slogan} light={item.light} />
        </div>
      </div>
      <span className="absolute top-3 left-3 bg-[#C8102E] text-white text-[10px] font-semibold uppercase tracking-wide-sm px-3 py-1 rounded-full">
        Coming Soon
      </span>
    </div>
    <div className="flex items-center justify-between gap-2">
      <div>
        <h3 className="font-body text-sm md:text-base font-semibold text-[#1A1A1A] leading-tight">
          {item.type}
        </h3>
        <p className="font-body text-xs text-[#888] mt-0.5">
          “{item.slogan}”
        </p>
      </div>
      <span className="font-body text-xs font-semibold text-[#999] whitespace-nowrap">
        Notify Me
      </span>
    </div>
  </div>
);

const MerchSection = () => {
  return (
    <section id="merch" className="bg-white py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        <MerchHeading />
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-5 md:gap-7">
          {merch.map((m) => (
            <MerchCard key={m.id} item={m} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default MerchSection;
